import { useTranslation } from 'react-i18next';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const selectItem = [
  {
    value: 'PAYU_CARD',
    translationName: 'paymentType.payUCard',
  },
  {
    value: 'STRIPE_CARD',
    translationName: 'paymentType.stripeCard',
  },
];
const SubscriptionPaymentTypesSelectItems = ({
  classes,
  paymentTypes,
  validateSetDefaultPaymentTypes,
  setPaymentTypes,
  modules,
}) => {
  const { t } = useTranslation();
  const MenuItemClasses = {
    root: classes.selectMenuItem,
    selected: classes.selectMenuItemSelectedMultiple,
  };

  return (
    <FormControl fullWidth={true} className={classes.selectFormControl}>
      <Select
        value={paymentTypes?.subscription?.defaultPaymentType}
        onChange={e => {
          // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- FIXME
          !validateSetDefaultPaymentTypes(e, 'subscription') &&
            setPaymentTypes(prev => ({
              ...prev,
              subscription: {
                ...prev.subscription,
                defaultPaymentType: e.target.value,
              },
            }));
        }}
        displayEmpty={true}
        name="dietSubscription"
        MenuProps={{ className: classes.selectMenu }}
        classes={{ select: classes.select }}
        disabled={!modules.ConfigClientPanel.isSubscriptionPaymentMode}
      >
        {selectItem.map(item => (
          <MenuItem
            key={item.value}
            value={item.value}
            classes={MenuItemClasses}
          >
            {t(item.translationName)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SubscriptionPaymentTypesSelectItems;
